import { notification } from 'antd';

const useCustomNotification = () => {
    const [api, contextHolder] = notification.useNotification();

    const openNotification = ({ message, description, duration = 3 }) => {
        api.open({
            message: message,
            description: description,
            duration: duration,
        });
    };

    return {
        openNotification,
        contextHolder,
    };
};

export default useCustomNotification;
